import i18n from '@/lang/i18n'

export default {
    title: i18n.t('configuration.elementTitle.archiveManagement'),
    id: 'units',
    sidebar: [
        {
            id: 'clients',
            label: i18n.tc('configuration.sections.archiveLevels'),
            icon: 'far fa-archive',
            routeName: 'ArchiveLevels',
            hasChildren: false
        }
    ]
}
